// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3P6Ev","insightsList":"newBusinessInsightsMenu_insightsList__3cXIo","active":"newBusinessInsightsMenu_active__N3_Gc"};